import {
  ARTICLE_VERSION_COMPARE,
  ARTICLE_VERSION_PUBLISH,
  DELETE_VERSION,
  GET_ALL_VERSIONS_ARTICLE,
  GET_ART_VERSION_DETAILS,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    // Task Templates--------------------->

    case GET_ALL_VERSIONS_ARTICLE:
      return {
        ...state,
        getAllVersion: action.payload,
      }

    case ARTICLE_VERSION_COMPARE:
      return {
        ...state,
        articleVersionCompareData: action.payload,
      }
    case GET_ART_VERSION_DETAILS:
      return {
        ...state,
        articleDetails: action.payload,
      }
    case 'CLEAR_GET_ART_VERSION_DETAILS':
      return {
        ...state,
        articleDetails: null,
      }
    case DELETE_VERSION:
      return {
        ...state,
        getAllVersion:
          state.getAllVersion && state.getAllVersion.filter(version => +action.payload.versionId !== version.id),
      }

    case ARTICLE_VERSION_PUBLISH:
      return {
        ...state,
        publishedVersionId: action.payload,
      }

    case 'CLEAR_ARTICLE_VERSION_PUBLISH':
      return {
        ...state,
        publishedVersionId: null,
      }

    default:
      return state
  }
}
